import apiConfig from "../../config/api";
import trace from "../../helpers/trace";
import store from "../../config/store";
import { ErrorSnacktOpen } from "../ErrorSnack/actions";
import mainState from "../Main/state";


// //////////////////
// Action Creators //
// //////////////////

export const ChangeGeneralDays = (days) => ({
  type: "GLOBAL/CHANGE_GENERAL_DAYS",
  days,
});

export const CargarTiposUnidad = (tiposUnidad) => ({
  type: "GLOBAL/CARGAR_TIPOS_UNIDAD",
  tiposUnidad,
});

export const CargarTiposPrestaciones = (tiposPrestaciones) => ({
  type: "GLOBAL/CARGAR_TIPOS_PRESTACIONES",
  tiposPrestaciones,
});

export const CargarTiposPrestacionesIsapre = (tiposPrestacionesIsapre) => ({
  type: "GLOBAL/CARGAR_TIPOS_PRESTACIONES_ISAPRE",
  tiposPrestacionesIsapre,
});

export const CargarItemIMED = (itemsImed) => ({
  type: "GLOBAL/CARGAR_ITEMS_IMED",
  itemsImed,
});

export const CargarTipoProfesional = (tiposProfesionales) => ({
  type: "GLOBAL/CARGAR_TIPOS_PROFESIONALES",
  tiposProfesionales,
});

export const CargarPertenenciaFonasa = (pertenenciasFonasa) => ({
  type: "GLOBAL/CARGAR_PERTENENCIA_FONASA",
  pertenenciasFonasa,
});

export const CargarEstadosSolicitud = (estadosSolicitud) => ({
  type: "GLOBAL/CARGAR_ESTADOS_SOLICITUD",
  estadosSolicitud,
});

export const CargarTiposSolicitud = (tiposSolicitud) => ({
  type: "GLOBAL/CARGAR_TIPOS_SOLICITUD",
  tiposSolicitud,
});

export const CargarCentrosAtencion = (centrosAtencion) => ({
  type: "GLOBAL/FILTRO_CARGAR_CENTROS_ATENCION",
  centrosAtencion,
});

export const CargarTiposArancel = (tiposArancel) => ({
  type: "GLOBAL/FILTRO_CARGAR_TIPOS_ARANCEL",
  tiposArancel,
});

export const CargarTiposArancelAll = (tiposArancel) => ({
  type: "GLOBAL/CARGAR_TIPOS_ARANCEL",
  tiposArancel,
});

export const CargarTiposArancelGeneral = (tiposArancelGeneral) => ({
  type: "GLOBAL/CARGAR_TIPOS_ARANCEL_GENERAL",
  tiposArancelGeneral,
});

export const CargarTiposPrestacion = (tiposPrestaciones) => ({
  type: "GLOBAL/FILTRO_CARGAR_TIPOS_PRESTACIONES",
  tiposPrestaciones,
});

export const CambiarCentroAtencion = (centroAtencion) => ({
  type: "GLOBAL/FILTRO_CAMBIAR_CENTRO_ATENCION",
  centroAtencion,
});

export const CambiarTipoArancel = (tipoArancel) => ({
  type: "GLOBAL/FILTRO_CAMBIAR_TIPO_ARANCEL",
  tipoArancel,
});

export const CambiarTipoPrestacion = (tipoPrestacion) => ({
  type: "GLOBAL/FILTRO_CAMBIAR_TIPO_PRESTACION",
  tipoPrestacion,
});

export const CambiarCodFonasa = (codFonasa) => ({
  type: "GLOBAL/FILTRO_CAMBIAR_CODIGO_FONASA",
  codFonasa,
});

export const CambiarCodPrestacion = (codPrestacion) => ({
  type: "GLOBAL/FILTRO_CAMBIAR_CODIGO_PRESTACION",
  codPrestacion,
});

export const SetVariablesSesion = (sesion) => ({
  type: "GLOBAL/SET_VARIABLES_SESION",
  sesion,
});

export const DialogGeneric = (accionModal, contenido) => ({
  type: "GLOBAL/DIALOG_GENERIC",
  accionModal,
  contenido,
});

export const GuardarTokenId = (token) => ({
  type: "GLOBAL/GUARDAR_TOKEN_ID",
  token,
});

export const CargarUsuariosContraloria = (usuariosContraloria) => ({
  type: "GLOBAL/CARGAR_USUARIOS_CONTRALORIA",
  usuariosContraloria,
});

export const CargarUsuariosConvenio = (usuariosConvenio) => ({
  type: "GLOBAL/CARGAR_USUARIOS_CONVENIO",
  usuariosConvenio,
});

export const cargarDatosUsuario = (datosUsuario) => ({
  type: "CARGAR_DATOS_USUARIO",
  datosUsuario,
});

export const CargarNombreInstitucion = (nombre) => ({
  type: "GLOBAL/CARGAR_NOMBRE_INSTITUCION",
  nombre,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const GetGeneralDays = (rutPrestador) => (dispatch) => {
  const { token } = store.getState().global;

  fetch(`${apiConfig.apiUri}/v1/vigencias/getVigenciasPrestador`, {
    method: "POST",
    credentials: "same-origin",
    body: JSON.stringify({ rutPrestador, token }),
  })
    .then((res) => {
      if (!res.ok) throw res;
      return res.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("GetGeneralDays", json);
        if (json.length > 0) {
          dispatch(ChangeGeneralDays(+json[0].days - 1));
        } else {
          fetch(`${apiConfig.apiUri}/v1/vigencias/getVigenciaGeneral`, {
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify({ token }),
          })
            .then((res) => {
              if (!res.ok) throw res;
              return res.json();
            })
            .then((json) => {
              if (json) {
                //trace.information("GetGeneralDays", json);
                dispatch(ChangeGeneralDays(+json[0].days - 1));
              } else throw json;
            })
            .catch((err) => {
              trace.information("GetGeneralDays", err);
              dispatch(ErrorSnacktOpen(
                "Error al obtener la vigencia general:",
                err,
              ));
            });
        }
      } else throw json;
    })
    .catch((err) => {
      trace.information("GetGeneralDays", err);
      dispatch(ErrorSnacktOpen(
        "Error al obtener la vigencia general:",
        err,
      ));
    });
};

export const ObtenerDatosUsuario = () => (dispatch) => {
  //console.log("OBTENER DATOS DE USUARIO");
  const globalState = store.getState().global;
  const params = {
    rutUsuario: globalState.rutUsuario,
    isapre: globalState.isapre,
    rutConvenio: globalState.rutInstitucion,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/usuarios/getDatosUsuario`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    crossDomain: true,
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => response.json())
    .then((json) => {
      dispatch(cargarDatosUsuario(json));
    })
    .catch((error) => {
      trace.error("BuscarPrestaciones", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los datos de usuario:",
        error,
      ));
    });
};

export const ObtenerTiposUnidad = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.tiposUnidad && globalState.tiposUnidad.length > 0) {
    return;
  }
  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/tipounidad/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposUnidad", json);
        dispatch(CargarTiposUnidad(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposUnidad", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los tipos de unidad:",
        error,
      ));
    });
};

export const ObtenerTiposPrestaciones = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.tiposPrestaciones && globalState.tiposPrestaciones.length > 0) {
    return;
  }

  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/prestacionesgrupos/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposPrestaciones", json);
        dispatch(CargarTiposPrestaciones(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposPrestaciones", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los tipos de prestaciones:",
        error,
      ));
    });
};

export const ObtenerTiposPrestacionesIsapre = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.tiposPrestacionesIsapre && globalState.tiposPrestacionesIsapre.length > 0) {
    return;
  }

  const params = {
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/prestacionesgrupos/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposPrestacionesIsapre", json);
        dispatch(CargarTiposPrestacionesIsapre(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposPrestacionesIsapre", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los tipos de prestaciones:",
        error,
      ));
    });
};

export const ObtenerItemImed = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.itemsImed &&
    globalState.itemsImed.length > 0) {
    return;
  }

  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/itemimed/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerItemImed", json);
        dispatch(CargarItemIMED(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerItemImed", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los item IMED:",
        error,
      ));
    });
};

export const ObtenerTipoProfesional = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.tiposProfesionales &&
    globalState.tiposProfesionales.length > 0) {
    return;
  }

  const params = {
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/parametros/tipoprofesional/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTipoProfesional", json);
        dispatch(CargarTipoProfesional(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTipoProfesional", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los tipos de profesionales:",
        error,
      ));
    });
};

export const ObtenerPertenenciaFonasa = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.pertenenciasFonasa &&
    globalState.pertenenciasFonasa.length > 0) {
    return;
  }
  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/perteneciafonasa/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerPertenenciaFonasa", json);
        dispatch(CargarPertenenciaFonasa(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerPertenenciaFonasa", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los tipos de pertenencia fonasa:",
        error,
      ));
    });
};

export const ObtenerEstadosSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.estadosSolicitud &&
    globalState.estadosSolicitud.length > 0) {
    return;
  }

  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/estadosolicitud`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerEstadosSolicitud", json);
        dispatch(CargarEstadosSolicitud(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerEstadosSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los estados de solicitud:",
        error,
      ));
    });
};

export const ObtenerTiposSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;

  if (globalState.tiposSolicitud &&
    globalState.tiposSolicitud.length > 0) {
    return;
  }

  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/tiposolicitud/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposSolicitud", json);
        dispatch(CargarTiposSolicitud(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "GLOBAL / Error al obtener los tipos de solicitud:",
        error,
      ));
    });
};

export const ObtenerCentrosAtencion = () => (dispatch) => {
  const globalState = store.getState().global;
  if (globalState.centrosAtencion && globalState.centrosAtencion.length > 0) {
    return;
  }
  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  //console.log("PARAMETROS DE ENTRADA >>> ", params);

  fetch(`${apiConfig.apiUri}/v1/centroatencion/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log("RESPONSE >>>> ", response);
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerCentrosAtencion", json);
        dispatch(GetGeneralDays(globalState.rutInstitucion.toString()));
        dispatch(CargarCentrosAtencion(json));
        if (json.length > 0) {
          dispatch(ObtenerTiposArancel(json[0].Secuencia));
          dispatch(ObtenerTiposPrestacion(json[0].Secuencia));
        }
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerCentrosAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los centros de atención",
        error,
      ));
    });
};

export const ObtenerTiposArancel = (centroAtencion) => (dispatch) => {
  const globalState = store.getState().global;
  // centroAtencion = null : Obtiene todos los tipos de arancel del prestador
  //trace.information("Carga Función ObtenerTiposArancel", centroAtencion);
  if (centroAtencion === null) {
    //trace.information("ObtenerTiposArancel con centroAtencion nulo, carga ObtenerTiposAracelAll");
    dispatch(ObtenerTiposArancelAll());
    return;
  }
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroAtencion: centroAtencion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  //trace.information("ObtenerTiposArancel [Se crea la variable params]", params);

  fetch(`${apiConfig.apiUri}/v1/aranceles/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposArancel", json);
        dispatch(CargarTiposArancel(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposArancel", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de arancel:",
        error,
      ));
    });
};

export const ObtenerTiposArancelAll = () => (dispatch) => {
  //trace.information("ObtenerTiposAracelAll [Se carga la función ObtenerTiposArancelAll]");
  const globalState = store.getState().global;
  if (globalState.tipoArancel && globalState.tipoArancel.length > 0) {
    //trace.information("ObtenerTiposAracelAll [Si globalState.TipoAracel no es nulo]");
    return;
  }

  // centroAtencion = null : Obtiene todos los tipos de arancel del prestador
  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  //trace.information("ObtenerTiposAracelAll [Se crea la variable params]", params);

  fetch(`${apiConfig.apiUri}/v1/aranceles/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposArancelAll", json);
        dispatch(CargarTiposArancelAll(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposArancelAll", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de arancel:",
        error,
      ));
    });
};

export const ObtenerTiposArancelGeneral= () => (dispatch) => {
  const globalState = store.getState().global;
  if (globalState.tipoArancel && globalState.tipoArancel.length > 0) {
    //trace.information("ObtenerTiposAracelAll [Si globalState.TipoAracel no es nulo]");
    return;
  }
  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/aranceles/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("CargarTiposArancelGeneral", json);
        dispatch(CargarTiposArancelGeneral(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposArancelGeneral", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de arancel:",
        error,
      ));
    });
};

export const ObtenerTiposPrestacion = (centroAtencion) => (dispatch) => {
  //trace.information("ObtenerTiposPrestacion [Se carga la función ObtenerTiposPrestación]");
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroAtencion: centroAtencion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  //trace.information("ObtenerTiposPrestacion [Se crea la variable params]", params);//asdasd

  fetch(`${apiConfig.apiUri}/v1/prestacionesgrupos/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposPrestacion", json);
        dispatch(CargarTiposPrestacion(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposPrestacion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de prestación:",
        error,
      ));
    });
};

export const doLogin = (rsaGuiId, callback) => (dispatch) => {
  const { rutInstitucion } = store.getState().global;
  // console.log("store getState global: ", store.getState().global);
  //console.log("rutInstitucion", rutInstitucion);

  const params = {
    rsaGuiId,
  };

  //console.log("RSA GUIID: " + rsaGuiId);

  //console.log("apiConfig URI >> ", apiConfig.apiUri);

  fetch(`${apiConfig.apiUri}/v1/usuarios/doLogin/`, {
    method: "POST",
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((response) => {
    setTimeout(() => null, 0);
    if (!response.ok) { throw response; }

    //console.log(response);

    return response.json();
  }).then((result) => {
    //trace.information("doLogin", result);
    dispatch(GuardarTokenId(result));
    //dispatch(GetGeneralDays(rutInstitucion.toString()));
    callback();
  }).catch((error) => {
    console.log("error", error);
    trace.error("doLogin", error);
    dispatch(ErrorSnacktOpen(
      "Error al autenticarse:",
      error,
    ));
  });
};

export const ObtenerUsuariosPerfil = (PerfilGuid, modulo) => (dispatch) => {
  mainState.isLoading = 0;
  const globalState = store.getState().global;
  const myHeaders = new Headers();
  myHeaders.append("PerfilGuid", PerfilGuid);
  myHeaders.append("Token", globalState.token);

  fetch(`${apiConfig.apiUri}/v1/usuarios/getUsuariosActivos/`, {
    method: "GET",
    headers: myHeaders,
    crossDomain: true,
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //console.log(json);
      if (Array.isArray(json)) {
        //trace.information("ObtenerUsuariosPerfil", json);
        if (modulo === 1) {
          dispatch(CargarUsuariosContraloria(json));
        } else {
          dispatch(CargarUsuariosConvenio(json));
        }
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerUsuariosPerfil", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los perfiles de usuario:",
        error,
      ));
    });
};

// export const GetValidateInputs = (value) => (dispatch) => {
//   console.log("VALOR PASADO: ", value);
// };



export const GetNombreInstitucion = () => (dispatch) => {
  //console.log("OBTENER NOMBRE DE INSTITUCION");
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/parametros/getHolding`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (json) {
        //trace.information("GetNombreInstitucion", json);
        dispatch(CargarNombreInstitucion(json.nombreHolding));
      }
    })
    .catch((error) => {
      trace.error("GetNombreInstitucion", error);
      /*
          dispatch(ErrorSnacktOpen(
            "Error al obtener nombre institucion:",
            error.message === "Failed to fetch" ? "No se encontro método API" : error
          ));
          */
    });
};
